export const professions = [
  { value: 'programmer', label: 'Programmer' },
  { value: 'designer', label: 'Designer' },
]
